import { CurrencyItemType } from "../store/slices/currencyListSlice";

export const currencyListForLink: CurrencyItemType[] = [
    {
        currencyId: 1,
        currencyDesc: "TL",
        currencyIsoCode: "949",
        currencyName: "TRY",
        currencySymbol: "₺"
    },
    {
        currencyId: 2,
        currencyDesc: "Euro",
        currencyIsoCode: "978",
        currencyName: "EUR",
        currencySymbol: "€"
    },
    {
        currencyId: 3,
        currencyDesc: "USD",
        currencyIsoCode: "840",
        currencyName: "USD",
        currencySymbol: "$"
    },
    {
        currencyId: 4,
        currencyDesc: "Sterlin",
        currencyIsoCode: "826",
        currencyName: "GBP",
        currencySymbol: "£"
    },
    {
        currencyId: 5,
        currencyDesc: "Rus Rublesi",
        currencyIsoCode: "643",
        currencyName: "RUB",
        currencySymbol: "₽"
    },
    {
        currencyId: 6,
        currencyDesc: "Japon Yeni",
        currencyIsoCode: "392",
        currencyName: "JPY",
        currencySymbol: "¥"
    },
    {
        currencyId: 7,
        currencyDesc: "Azerbaycan Manatı",
        currencyIsoCode: "944",
        currencyName: "AZN",
        currencySymbol: "₼"
    },
    {
        currencyId: 8,
        currencyDesc: "İsviçre Frangı",
        currencyIsoCode: "756",
        currencyName: "CHF",
        currencySymbol: "Fr"
    },
    {
        currencyId: 9,
        currencyDesc: "Kuveyt Dinarı",
        currencyIsoCode: "414",
        currencyName: "KWD",
        currencySymbol: "ك"
    },
];